import React, { createContext, useState, useContext, ReactNode } from 'react';
import { ExaminersList } from '../components/ExaminersStructure/ExaminersStructure.types';

interface IUseExaminer {
  examiner: ExaminersList | undefined;
  setExaminer: React.Dispatch<React.SetStateAction<ExaminersList | undefined>>;
  team: ExaminersList | undefined;
  setTeam: (team: ExaminersList) => void;
  forceReloadExaminersTreemap: boolean;
  setForceReloadExaminersTreemap: React.Dispatch<React.SetStateAction<boolean>>;
}

const ExaminerContext = createContext<IUseExaminer>({
  examiner: undefined,
  setExaminer: () => undefined,
  team: undefined,
  setTeam: () => undefined,
  forceReloadExaminersTreemap: false,
  setForceReloadExaminersTreemap: () => undefined,
});

export const ExaminerProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [examiner, setExaminer] = useState<ExaminersList | undefined>(undefined);
  const [team, setTeam] = useState<ExaminersList | undefined>(undefined);
  const [forceReloadExaminersTreemap, setForceReloadExaminersTreemap] = useState<boolean>(false);

  return (
    <ExaminerContext.Provider
      value={{ examiner, setExaminer, team, setTeam, forceReloadExaminersTreemap, setForceReloadExaminersTreemap }}
    >
      {children}
    </ExaminerContext.Provider>
  );
};

export const useExaminer = () => {
  const context = useContext(ExaminerContext);
  if (!context) throw new Error('no <ExaminerProvider> wrapper');
  return context;
};
